import { combineReducers, isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { redirect } from 'react-router-dom';
import { authAPI } from './auth';
import filterStateReducer from './filterState';
import keypointFilterStateReducer from './keypointFilterState';
import viewLabelFilterStateReducer from './viewLabelFilterState';
import segmentationPredictionFilterReducer from './segmentationPredictionFilterState';
import predictionFilterReducer from './predictionFilterState';
import { reviewsAPI } from './reviews';
import { viewsAPI } from './views';
import { usersAPI } from './users';
import { keypointsAPI } from './keypoints';
import { FrameWithLabelAndPredictionapi } from './predictions';
import { threeDStudyAPI } from './threeDStudy';

export const rtkQueryErrorLogger: Middleware = () => next => (action: any) => {
  if (isRejectedWithValue(action)) {
    if (action.payload.status === 401 || action.payload.status === 403) {
      console.log('Bad permissions');
      redirect('/login');
    }
  }

  return next(action);
};

const rootReducer = combineReducers({
  [authAPI.reducerPath]: authAPI.reducer,
  filterState: filterStateReducer,
  keypointFilterState: keypointFilterStateReducer,
  viewLabelFilterState: viewLabelFilterStateReducer,
  segmentationPredictionFilter: segmentationPredictionFilterReducer,
  predictionFilter: predictionFilterReducer,
  [reviewsAPI.reducerPath]: reviewsAPI.reducer,
  [viewsAPI.reducerPath]: viewsAPI.reducer,
  [usersAPI.reducerPath]: usersAPI.reducer,
  [keypointsAPI.reducerPath]: keypointsAPI.reducer,
  [FrameWithLabelAndPredictionapi.reducerPath]: FrameWithLabelAndPredictionapi.reducer,
  [threeDStudyAPI.reducerPath]: threeDStudyAPI.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
